import { db } from './db';
import bcrypt from 'bcryptjs';

const STORAGE_KEY = 'antacres_auth_session';

class Auth {
  constructor() {
    this.session = this.loadSession();
  }

  loadSession() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        return JSON.parse(stored);
      } catch (e) {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
    return null;
  }

  saveSession(session) {
    if (session) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
    this.session = session;
  }

  async validateCredentials(email, password) {
    try {
      const result = await db.execute({
        sql: 'SELECT id, email, hashed_password, role FROM users WHERE email = ?',
        args: [email]
      });

      if (result.rows.length === 0) {
        throw new Error('Invalid credentials');
      }

      const user = result.rows[0];

      const passwordMatch = await bcrypt.compare(password, user.hashed_password);

      if (passwordMatch) {
        return {
          userId: user.id,
          email: user.email,
          role: user.role
        };
      } else {
        throw new new Error('Invalid credentials');
      }
    } catch (error) {
      console.error("Authentication error:", error);
      throw new Error('Invalid credentials');
    }
  }

  async createSession(credentials) {
    try {
      const user = await this.validateCredentials(credentials.email, credentials.password);
      const session = {
        user,
        createdAt: new Date().toISOString(),
        expiresAt: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString()
      };
      this.saveSession(session);
      return session;
    } catch (error) {
      error.code = 'auth/invalid-credentials';
      throw error;
    }
  }

  async validateSession() {
    const session = this.loadSession();
    if (!session) return null;

    if (new Date(session.expiresAt) < new Date()) {
      this.invalidateSession();
      return null;
    }

    return session;
  }

  async invalidateSession() {
    this.saveSession(null);
  }
}

export const auth = new Auth();